var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrokenGlassSensor({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.6,2.9c-2.2,0-4,1.4-4.8,3.3L10.6,8L5.8,9.8c0.7,1.9,2.6,3.3,4.8,3.3c2.8,0,5.1-2.3,5.1-5.1 S13.4,2.9,10.6,2.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0.7,6.2C0.4,6.7,0.3,7.3,0.3,8s0.1,1.3,0.4,1.8L5.4,8L0.7,6.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrokenGlassSensor);
export default __webpack_public_path__ + "static/media/BrokenGlassSensor.95bcd72011e43b9568f5fe1a4f00f4c6.svg";
export { ForwardRef as ReactComponent };